import {
  POST_CUSTOMER_BEGIN, POST_CUSTOMER_SUCCESS, POST_CUSTOMER_FAILURE
} from './../constants/ActionTypes'

const initialState = {
  loadingCustomerPost: false,
  errorCustomerPost: null
}

const ReducerRegister = (state = initialState, { type, payload }) => {
  switch (type) {
    case POST_CUSTOMER_BEGIN: {
      return {
        ...state,
        loadingCustomerPost: true,
        errorCustomerPost: null
      }
    }
    case POST_CUSTOMER_SUCCESS: {
      return {
        ...state,
        loadingCustomerPost: false,
        errorCustomerPost: null
      }
    }
    case POST_CUSTOMER_FAILURE: {    
      return {
        ...state,
        loadingCustomerPost: false,
        errorCustomerPost: payload
      }
    }
    default: {
      return state
    }
  }
}

export default ReducerRegister
